<template>
    <a-modal :visible="isShow" title="备注" ok-text="确认" cancel-text="取消" @ok="ok" @cancel="cancel">
        <!-- <a-input v-model="remark" placeholder="添加备忘录信息，仅自己可见" /> -->
        <a-textarea v-model="computedRemark" placeholder="添加备忘录信息，仅自己可见" />
    </a-modal>
</template>

<script>
export default {
    name: 'RemarkModal',
    props: {
        isShow: {
            type: Boolean,
        },
        msg: {
            type: String,
            required: true
        },
        buyer_message: {
            type: String,
        }
    },
    data() {
        return {
            remark: '',
        }
    },

    computed: {
        computedRemark: {
            get() {
                return this.isShow ? (this.buyer_message || this.msg) : this.remark;
            },
            set(value) {
                this.remark = value;
            }
        }
    },
    methods: {
        ok() {
            this.$emit('remark', this.remark)
        },
        cancel() {
            this.$emit('update:isShow', false)
        }
    },
    watch: {
        msg: {
            handler(msg) {
                this.remark = msg
            },
            immediate: true
        },
        isShow(isShow) {
            if (isShow && this.buyer_message && this.buyer_message.length != 0) {
                this.remark = this.buyer_message;
            } else {
                this.remark = this.msg;
            }
        }
    }
}
</script>


<style scoped>
>>>.ant-modal-title {
    padding: 0 10px;
    box-sizing: border-box;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
}

>>>.ant-modal-close-x {
    margin-right: 12px;
}

>>>.ant-modal-body {
    height: 108px;
    position: relative;
}


textarea {
    resize: none;
    border: none;
}

>>>.ant-modal-footer {
    height: 80px;
    padding: 30px 35px 20px;
}

>>>.ant-btn {
    width: 60px;
    height: 32px;
    min-width: unset;
    background-color: #E7E7E7;
}
</style>


// WEBPACK FOOTER //
// src/components/deal/orders/RemarkModal.vue